import classNames from 'classnames';
import React, { ReactElement } from 'react';

interface Props {
  /**
   * Contents of the buttons.
   *
   * Takes precedence over the label, if present.
   */
  children?: ReactElement<any>;

  /**
   * Additional class names beyond the defaults.
   */
  className?: string;
  disabled?: boolean;

  /**
   * Text within the button.
   *
   * Present for consistency with Field types.
   *
   * This will be used only if there are no children.
   */
  label?: string;
}

const SubmitButton = ({ children = null, className = null, label = null, ...props }: Props) => {
  const cls = classNames('btn', 'btn-primary', className);
  return (
    <button type="submit" className={cls} {...props}>
      {children || label}
    </button>
  );
};

export default SubmitButton;
